import {reactLocalStorage} from "reactjs-localstorage";
import Const from "../../const";

const isSameOrder = (order1, order2) => {
    const phone1 = order1.custPhone || order1.phone;
    const phone2 = order2.custPhone || order2.phone;
    const price1 = order1.orderPrice || order1.price;
    const price2 = order2.orderPrice || order2.price;
    const isSame = phone1 === phone2 && price1 === price2 &&
                (order1.destAddr1 === order2.destAddr1 || (order1.destAddr3 === order2.destAddr1 || order1.destAddr1 === order2.destAddr3)) &&
                order1.destAddr2 === order2.destAddr2;
    //console.log('isSameOrder result : ' + isSame);
    return isSame;
};

const isExistsPendingOrder = (order) => {
    let orderInfo = null;
    let pendingOrders = reactLocalStorage.getObject(Const.appName + '#pendingOrders');
    if (!Array.isArray(pendingOrders) || pendingOrders.length === 0)
        return false;

    const orderIdx= pendingOrders.indexOf(order.id);
    return -1 < orderIdx;
};

const addPendingOrder = (order) => {
    if (isExistsPendingOrder(order))
        return;

    let pendingOrders = reactLocalStorage.getObject(Const.appName + '#pendingOrders') || [];
    if (!Array.isArray(pendingOrders)) {
        pendingOrders = [];
    }
    pendingOrders.push(order.id);
    reactLocalStorage.setObject(Const.appName + '#pendingOrders', pendingOrders);
};

const removePendingOrder = (order) => {
    if (!isExistsPendingOrder(order))
        return;

    let pendingOrders = reactLocalStorage.getObject(Const.appName + '#pendingOrders') || [];
    if (!Array.isArray(pendingOrders))
        return;

    const delIdx= pendingOrders.indexOf(order.id);
    if(delIdx < 0)
        return;

    pendingOrders.splice(delIdx, 1);
    reactLocalStorage.setObject(Const.appName + '#pendingOrders', pendingOrders);
};

export {
    isSameOrder,
    isExistsPendingOrder,
    addPendingOrder,
    removePendingOrder,
};
